import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const planningNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Planning,
  icon: 'assignment',
  route: `/${RoutesEnum.Planning}`,
};
